export enum LicenseKeyFilter {
    ALL = "ALL",
    ACTIVE = "ACTIVE",
    DISABLED = "DISABLED",
    EXPIRED = "EXPIRED",
    USED = "USED",
}
